@switch (bannerStyle) {
  @case ('Full') {
    <div class="flex flex-col items-center md:flex-row w-full gap-2 md:gap-8 justify-between px-6 py-4 box-border">
      <div class="text-2xl md:text-4xl font-bold">
        @if (!hasReviews) {
          <p>
            Grow your 5-star reviews <br class="hidden md:block" />
            <span class="!text-highlight-blue">effortlessly</span> with PRO
          </p>
        }
        @if (hasReviews) {
          <p>
            Get found first <br class="hidden md:block" />
            <span class="!text-highlight-blue">on Google search</span> with PRO
          </p>
        }
      </div>
      <div class="flex flex-col sm:flex-row md:flex-col md:max-w-[150px] items-center gap-4">
        <img
          [src]="'promotion-banner/remax/preferred-supplier-xl.png' | staticAsset: 'image'"
          alt="Preferred REMAX supplier"
          class="w-full h-12 md:h-auto"
        />
        <a
          routerLink="/billing/subscription-features"
          [queryParams]="{ source: !hasReviews ? 'remax' : 'remax-google' }"
          mat-raised-button
          class="!bg-highlight-pink !text-white !min-w-[150px]"
        >
          Start free trial
        </a>
      </div>
    </div>
  }
  @case ('Small') {
    <div class="w-full p-3 text-center text-white">
      You're one step away from starting your <span class="!text-highlight-blue">free trial</span>
    </div>
  }
}
